import styled from 'styled-components'
import Input from 'antd/lib/input'

const Search = Input.Search

export const HeaderRoot = styled.header`
  display: flex;
  flex-direction: column;
  width: 100%;

  #ProductCount {
    margin-block: var(--spacing-16);
    font: 400 14px/22px var(--font-inter);
    color: var(--neutral-secondary);
  }

  @media (max-width: 768px) {
    #ProductCount {
      margin-top: 0;
    }
  }
`

export const PageHeading = styled.h1`
  margin: 0 0 var(--spacing-16);
  padding-bottom: var(--spacing-16);
  border-bottom: var(--border-regular) solid var(--neutral-border-light);
  font: 700 40px/42px var(--font-barlow-semi-condensed);
  color: var(--neutral-darkest);

  @media (max-width: 768px) {
    font: 700 24px/30px var(--font-barlow-semi-condensed);
    letter-spacing: 0.44px;
    margin-bottom: var(--spacing-12);
    padding-bottom: var(--spacing-12);
  }
`

export const FilterBarRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-16);
  margin-bottom: var(--spacing-12);

  #FilterButtons {
    order: 1;
  }
  #SearchField {
    order: 2;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: var(--spacing-12);
    #FilterButtons {
      order: 2;
    }
    #SearchField {
      order: 1;
    }
  }
`

export const FilterButtonsScroll = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-8);
  min-width: 0;

  @media (max-width: 768px) {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: var(--spacing-4);
    margin-right: -14px;
    padding-right: 14px;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const FilterSortButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-8);
  flex-shrink: 0;
  height: var(--catalog-filter-btn-height);
  padding: 0 var(--spacing-16);
  border: var(--border-regular) solid var(--neutral-border-med);
  background: var(--neutral-white);
  cursor: pointer;
  font: 600 12px/18px var(--font-barlow);
  letter-spacing: 1.12px;
  text-transform: uppercase;
  color: var(--neutral-darkest);
  white-space: nowrap;

  .filter-sort-icon {
    font: 14px/1 var(--font-inter);
    color: var(--neutral-darkest);
  }

  &:hover,
  &:focus {
    outline: none;
    border: var(--border-regular) solid var(--neutral-darkest);
  }
`

export const FilterShortcutButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: var(--catalog-filter-btn-height);
  padding: 0 var(--spacing-16);
  border: var(--border-regular) solid var(--neutral-border-med);
  background: var(--neutral-white);
  cursor: pointer;
  font: 600 12px/18px var(--font-barlow);
  letter-spacing: 1.12px;
  text-transform: uppercase;
  color: var(--neutral-darkest);
  white-space: nowrap;

  &:hover,
  &:focus {
    border-color: var(--neutral-darkest);
    background: var(--neutral-fill-lightest);
    outline: none;
  }
`

export const SearchWrapper = styled.div`
  flex-shrink: 0;
  width: var(--catalog-search-width-desktop);

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const SearchInput = styled(Search)`
  width: 100%;

  .ant-input {
    height: var(--catalog-search-height);
    padding: 0 var(--spacing-12);
    border: var(--border-regular) solid var(--neutral-border-med);
    border-radius: 4px;
    font: 400 14px/20px var(--font-inter);
    color: var(--neutral-darkest);

    &::placeholder {
      color: var(--neutral-muted);
    }
  }

  .ant-input-search-button {
    display: none;
  }
  &:hover .ant-input:not(.ant-input-disabled) {
    border-color: var(--neutral-darkest);
    box-shadow: none;
  }
`

export const TagsRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--spacing-12);
  margin-bottom: var(--spacing-12);

  @media (max-width: 768px) {
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: var(--spacing-4);

    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const ClearAllLink = styled.button`
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font: 400 13px/17px var(--font-inter);
  text-decoration: underline;
  color: var(--neutral-body);
  white-space: nowrap;

  &:hover,
  &:focus {
    color: var(--neutral-darkest);
    outline: none;
  }
`

export const FilterTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-8);
  flex-shrink: 0;
  height: var(--catalog-filter-tag-height);
  padding: 0 var(--spacing-12);
  border: var(--border-regular) solid var(--neutral-border-med);
  background: var(--neutral-border-med);
  font: 400 13px/17px var(--font-inter);
  color: var(--neutral-body);
  text-transform: capitalize;
  white-space: nowrap;
`

export const TagRemoveButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font: 400 12px/1 var(--font-inter);
  color: var(--neutral-body);

  &:hover,
  &:focus {
    color: var(--neutral-darkest);
    outline: none;
  }
`

export const SearchResultsRow = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-12);
  margin-bottom: var(--spacing-12);
  font: 400 14px/22px var(--font-inter);
  color: var(--neutral-body);
`

export const ClearSearchLink = styled.button`
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: transparent;
  margin-right: 12px;
  cursor: pointer;
  font: 400 13px/17px var(--font-inter);
  text-decoration: underline;
  color: var(--neutral-body);
  white-space: nowrap;

  &:hover,
  &:focus {
    color: var(--neutral-darkest);
    outline: none;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ProductCatalogueV2/CatalogPageHeader/styledComponents.tsx